import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleCrossed: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBubbleCrossed"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V19H15.2858L11.9951 21.7263L8.74274 19H3V3ZM15.182 8.85313L14.1213 7.79247L12 9.91379L9.87868 7.79247L8.81802 8.85313L10.9393 10.9745L8.81802 13.0958L9.87868 14.1564L12 12.0351L14.1213 14.1564L15.182 13.0958L13.0607 10.9745L15.182 8.85313Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleCrossed;
